(function bootstrapEbankAffiliateProgram() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (!/(^|\.)ebank\.nz$/i.test(window.location.hostname)) return;

  var affiliateURL = 'https://ebank.evangeler.com';
  window.evangelTrackingCode = 'ebank_Adv8qGvG5voXkl9Cgv93FvUjzbvt_n3m';
  window.evangelFirstPurchaseOnly = true;
  window.evangelPurchaseAmounts = { monthly: 9, annual: 90 };

  if (!document.querySelector('script[src*="evangeler-tracking.js"]')) {
    var trackingScript = document.createElement('script');
    trackingScript.src = 'https://ebank.evangeler.com/static/js/evangeler-tracking.js';
    trackingScript.defer = true;
    (document.head || document.documentElement).appendChild(trackingScript);
  }

  function affiliateLink(className, label, withIcon) {
    var link = document.createElement('a');
    link.className = className;
    link.href = affiliateURL;
    link.target = '_blank';
    link.rel = 'noopener';
    link.setAttribute('data-bypass', 'true');
    link.title = 'Affiliate Program - Earn 20%';
    if (withIcon) {
      var icon = document.createElement('i');
      icon.className = 'material-icons dp48';
      icon.textContent = 'share';
      link.appendChild(icon);
      link.appendChild(document.createTextNode(' '));
    }
    link.appendChild(document.createTextNode(label));
    return link;
  }

  function installAffiliateLinks() {
    if (document.querySelector('a[href="' + affiliateURL + '"]')) return;

    var desktopNav = document.querySelector('header.ws-header nav.mdl-navigation');
    if (desktopNav) {
      var desktopLink = affiliateLink(
        'mdl-navigation__link ebank-nav-link',
        'Affiliates',
        true
      );
      desktopNav.insertBefore(
        desktopLink,
        desktopNav.querySelector('.header-login-signup')
      );
    }

    var drawerNav = document.querySelector('.mdl-layout__drawer nav.mdl-navigation');
    if (drawerNav) {
      var drawerLink = affiliateLink('mdl-navigation__link', 'Affiliates', true);
      drawerNav.insertBefore(
        drawerLink,
        drawerNav.querySelector('.header-login-signup')
      );
    }

    var footerHeadings = document.querySelectorAll('.mdl-mega-footer__heading');
    for (var i = 0; i < footerHeadings.length; i++) {
      if (footerHeadings[i].textContent.trim() !== 'Company') continue;
      var section = footerHeadings[i].closest('.mdl-mega-footer__drop-down-section');
      var list = section && section.querySelector('.mdl-mega-footer__link-list');
      if (list) {
        var item = document.createElement('li');
        item.appendChild(affiliateLink('', 'Affiliate Program - Earn 20%', false));
        list.appendChild(item);
      }
      break;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installAffiliateLinks);
  } else {
    installAffiliateLinks();
  }
})();

(function initExternalCharacterHandoff() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function apply() {
    const params = new URLSearchParams(window.location.search || '');
    if (params.get('create_character') !== '1') return;
    const dialog = document.getElementById('create-new-ai-dialog');
    const form = document.getElementById('add-new-ai-form');
    if (!dialog || !form) return;

    const setValue = (selector, value) => {
      const field = form.querySelector(selector);
      if (field && value) field.value = value;
    };
    const avatarURL = params.get('avatar_url')?.trim() || '';
    setValue('[name="ainame"]', params.get('name')?.trim() || 'New character');
    setValue('[name="aidescription"]', params.get('description')?.trim() || 'An original character with a distinctive point of view.');
    setValue('[name="aigreeting"]', params.get('greeting')?.trim() || 'What kind of story are we stepping into?');
    setValue('[name="newaiavatarurl"]', avatarURL);
    if (avatarURL) {
      const avatar = document.getElementById('new-ai-avatar-image');
      if (avatar) {
        avatar.replaceChildren();
        const image = document.createElement('img');
        image.src = avatarURL;
        image.alt = 'Character avatar';
        image.style.cssText = 'width:71px;height:71px;border-radius:50%;object-fit:cover';
        avatar.appendChild(image);
      }
    }
    if (!dialog.open) dialog.showModal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else setTimeout(apply, 0);
})();

(function installShowToastOnce() {
  if (typeof window === 'undefined' || window.showToast) return;

  function ensureContainer() {
    var container = document.getElementById('netwrck-toast-container');
    if (container) return container;
    container = document.createElement('div');
    container.id = 'netwrck-toast-container';
    container.style.cssText = [
      'position:fixed',
      'left:50%',
      'bottom:24px',
      'transform:translateX(-50%)',
      'z-index:2147483600',
      'display:flex',
      'flex-direction:column',
      'gap:8px',
      'pointer-events:none',
      'max-width:calc(100% - 32px)'
    ].join(';');
    if (document.body) {
      document.body.appendChild(container);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        if (!document.getElementById('netwrck-toast-container')) {
          document.body.appendChild(container);
        }
      });
    }
    return container;
  }

  function colorFor(type) {
    switch (type) {
      case 'success': return '#16a34a';
      case 'warning': return '#d97706';
      case 'error':   return '#dc2626';
      default:        return '#1f2937';
    }
  }

  window.showToast = function (message, opts) {
    if (!message) return;
    opts = opts || {};
    var timeout = typeof opts.timeout === 'number' ? opts.timeout : 4000;
    var type = opts.type || 'info';

    try {
      var legacy = document.getElementById('toast');
      if (legacy && legacy.MaterialSnackbar && typeof legacy.MaterialSnackbar.showSnackbar === 'function') {
        legacy.MaterialSnackbar.showSnackbar({ message: String(message), timeout: timeout });
        return;
      }
    } catch (e) { /* fall through */ }

    var container = ensureContainer();
    if (!container) {
      try { console.log('[toast]', message); } catch (e) {}
      return;
    }

    var toast = document.createElement('div');
    toast.setAttribute('role', 'status');
    toast.style.cssText = [
      'background:' + colorFor(type),
      'color:#fff',
      'padding:10px 16px',
      'border-radius:6px',
      'font:14px/1.4 -apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif',
      'box-shadow:0 8px 20px rgba(0,0,0,0.25)',
      'opacity:0',
      'transform:translateY(10px)',
      'transition:opacity .18s ease, transform .18s ease',
      'pointer-events:auto',
      'max-width:480px',
      'word-break:break-word'
    ].join(';');
    toast.textContent = String(message);
    container.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });

    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(10px)';
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 220);
    }, timeout);
  };
})();

// Install robust, idempotent global modal handlers early, even if jQuery isn't present
(function installGlobalModalHandlersOnce() {
  if (window.__modalGlobalInstalled) return;
  window.__modalGlobalInstalled = true;
  const backdropPointerDown = new WeakMap();

  function getDialogEventPoint(event) {
    const source =
      event && event.changedTouches && event.changedTouches.length
        ? event.changedTouches[0]
        : event && event.touches && event.touches.length
          ? event.touches[0]
          : event;
    if (!source) return null;
    if (!Number.isFinite(source.clientX) || !Number.isFinite(source.clientY)) {
      return null;
    }
    return { x: source.clientX, y: source.clientY };
  }

  function isOutsideDialogBox(dialog, event) {
    if (!dialog || typeof dialog.getBoundingClientRect !== 'function') return false;
    const point = getDialogEventPoint(event);
    if (!point) return false;
    const rect = dialog.getBoundingClientRect();
    return (
      point.x < rect.left ||
      point.x > rect.right ||
      point.y < rect.top ||
      point.y > rect.bottom
    );
  }

  function trackDialogPointerDown(event) {
    const dialog = event && event.target;
    if (!dialog || !dialog.tagName || dialog.tagName.toLowerCase() !== 'dialog') return;
    backdropPointerDown.set(dialog, isOutsideDialogBox(dialog, event));
  }

  function isDialogBackdropClick(dialog, event) {
    if (!dialog || event.target !== dialog) return false;
    if (dialog.getAttribute('data-backdrop') === 'static') return false;
    if (!isOutsideDialogBox(dialog, event)) return false;
    return backdropPointerDown.get(dialog) === true;
  }

  window.__isDialogBackdropClick = isDialogBackdropClick;

  document.addEventListener('pointerdown', trackDialogPointerDown, true);
  document.addEventListener('mousedown', trackDialogPointerDown, true);
  document.addEventListener('touchstart', trackDialogPointerDown, true);

  if (
    typeof window.HTMLDialogElement !== 'undefined' &&
    !window.__dialogPolyfillNormalized
  ) {
    const proto = window.HTMLDialogElement.prototype;
    if (proto) {
      const originalShow = proto.show;
      if (typeof originalShow === 'function') {
        proto.show = function (...args) {
          if (this && this.style) {
            this.style.display = '';
          }
          return originalShow.apply(this, args);
        };
      }

      const originalShowModal = proto.showModal;
      if (typeof originalShowModal === 'function') {
        proto.showModal = function (...args) {
          if (this && this.style) {
            this.style.display = '';
          }
          return originalShowModal.apply(this, args);
        };
      }

      const originalClose = proto.close;
      if (typeof originalClose === 'function') {
        proto.close = function (...args) {
          try {
            return originalClose.apply(this, args);
          } finally {
            if (this && this.style) {
              this.style.display = '';
            }
          }
        };
      }
    }
    window.__dialogPolyfillNormalized = true;
  }

  // Backdrop clicks: close native <dialog> unless opted out
  document.addEventListener(
    'click',
    function (event) {
      try {
        const t = event.target;
        if (!t || !t.tagName) return;
        if (t.tagName.toLowerCase() !== 'dialog') return;
        if (!isDialogBackdropClick(t, event)) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        if (typeof t.close === 'function' && t.open) {
          t.close();
          t.style && (t.style.display = '');
        } else {
          t.removeAttribute && t.removeAttribute('open');
          if (typeof t.showModal !== 'function') {
            t.style && (t.style.display = 'none');
          } else if (t.style) {
            t.style.display = '';
          }
        }
        event.preventDefault();
        event.stopPropagation();
      } catch (e) {
        console.warn('[shared] backdrop close error', e);
      }
    },
    true
  );

  // Delegated close buttons: broad selector set, support non-native containers
  document.addEventListener(
    'click',
    function (event) {
      try {
        const closeBtn =
          event.target && event.target.closest
            ? event.target.closest(
                '.close, .mdl-button.close, button.close, .close-dialog, .modal-close, [data-dismiss="modal"], [data-dismiss="dialog"], [data-dialog-close], [data-close]'
              )
            : null;
        if (!closeBtn) return;
        const container =
          closeBtn.closest &&
          closeBtn.closest('dialog, .mdl-dialog, [role="dialog"]');
        if (!container) return;

        if (container.tagName && container.tagName.toLowerCase() === 'dialog') {
          if (typeof container.close === 'function' && container.open) {
            container.close();
            container.style && (container.style.display = '');
          } else {
            container.removeAttribute && container.removeAttribute('open');
            if (typeof container.showModal !== 'function') {
              container.style && (container.style.display = 'none');
            } else if (container.style) {
              container.style.display = '';
            }
          }
        } else {
          // Non-native container fallback
          container.style && (container.style.display = 'none');
          container.classList && container.classList.remove('open');
        }
        event.preventDefault();
        event.stopPropagation();
      } catch (e) {
        console.warn('[shared] delegated close error', e);
      }
    },
    true
  );
})();

// Continue with page-specific setup; jQuery optional
var __sharedReady = function () {
  var dialogs = document.querySelectorAll('dialog');
  dialogs.forEach(function (dialog) {
    // Handle backdrop clicks (clicking outside the dialog content)
    dialog.addEventListener('click', function (event) {
      // Check if we clicked on the dialog backdrop (::backdrop pseudo-element)
      // The dialog element itself is the target when clicking the backdrop
      if (
        window.__isDialogBackdropClick
          ? window.__isDialogBackdropClick(dialog, event)
          : event.target === dialog && dialog.getAttribute('data-backdrop') !== 'static'
      ) {
        dialog.close();
      } else if (event.target === dialog) {
        event.preventDefault();
        event.stopPropagation();
      }
    });

    // Handle close button clicks
    var closeButtons = dialog.querySelectorAll(
      '.close, .mdl-button.close, button.close, .close-dialog, .modal-close, [data-dismiss="modal"], [data-dismiss="dialog"], [data-dialog-close], [data-close]'
    );
    closeButtons.forEach(function (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
          dialog.style && (dialog.style.display = '');
        } else {
          dialog.removeAttribute && dialog.removeAttribute('open');
          if (typeof dialog.showModal !== 'function') {
            dialog.style && (dialog.style.display = 'none');
          } else if (dialog.style) {
            dialog.style.display = '';
          }
        }
      });
    });
  });

  // Global delegated handler: catch clicks on any future `.close` button inside a dialog
  // This ensures Close works for dialogs injected after DOM ready (e.g., auth modals)
  document.addEventListener(
    'click',
    function (event) {
      const closeBtn =
        event.target && event.target.closest
          ? event.target.closest(
              '.close, .mdl-button.close, button.close, .close-dialog, .modal-close, [data-dismiss="modal"], [data-dismiss="dialog"], [data-dialog-close], [data-close]'
            )
          : null;
      if (!closeBtn) return;
      const dialog = closeBtn.closest('dialog');
      if (!dialog) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
        dialog.style && (dialog.style.display = '');
      } else {
        dialog.removeAttribute && dialog.removeAttribute('open');
        if (typeof dialog.showModal !== 'function') {
          dialog.style && (dialog.style.display = 'none');
        } else if (dialog.style) {
          dialog.style.display = '';
        }
      }
    },
    true
  );

  document.addEventListener(
    'close',
    function (event) {
      const dialog = event && event.target;
      if (!dialog || dialog.tagName?.toLowerCase() !== 'dialog') return;
      dialog.style && (dialog.style.display = '');
    },
    true
  );

  // Ensure demo-ribbon exists on Account page
  try {
    if (
      window.location &&
      window.location.pathname &&
      window.location.pathname.indexOf('/account') !== -1
    ) {
      if (!document.querySelector('.demo-ribbon')) {
        var ribbon = document.createElement('div');
        ribbon.className = 'demo-ribbon';
        if (document.body) {
          document.body.insertBefore(ribbon, document.body.firstChild);
        }
      }
    }
  } catch (e) {
    console.warn('demo-ribbon injection failed', e);
  }

  // Ensure bililiteRange/jQuery sendkeys plugin is loaded before game usage
  try {
    const needSendkeys = !!document.querySelector(
      '#createaiimageprompt, .question-text, #searchusers, #searchusersforroom'
    );
    const hasPlugin = window.$ && $.fn && typeof $.fn.sendkeys === 'function';
    const staticBase = (window.STATIC_URL && String(window.STATIC_URL)) || '/static';
    const bililitePath = staticBase.replace(/\/$/, '') + '/libs/bililiteRange.js';
    const alreadyLoaded = Array.from(document.scripts).some(
      (s) => s.src && (s.src.includes('/libs/bililiteRange.js') || s.src.includes('bililiteRange.js'))
    );
    if (needSendkeys && !hasPlugin && !alreadyLoaded) {
      const s = document.createElement('script');
      s.src = bililitePath;
      document.head.appendChild(s);
    }
  } catch (_) {
    // Ignore errors from parsing
  }

  function handleAIControlsClick(event) {
    if (event) {
      event.preventDefault();
    }

    var aiSettingsDialog = document.getElementById('ai-settings-dialog');
    if (aiSettingsDialog) {
      loadAISettings();
      aiSettingsDialog.showModal();
      return;
    }

    var createAIDialog = document.getElementById('create-new-ai-dialog');
    var findAIDialog = document.getElementById('find-room-dialog');
    if (createAIDialog) {
      createAIDialog.showModal();
      return;
    }
    if (findAIDialog) {
      findAIDialog.showModal();
      return;
    }

    console.log('AI Controls clicked - no dialog found');
    alert('AI Controls: Create or manage AI characters from the menu.');
  }

  var aiControlBtn = document.getElementById('ai-control-btn');
  if (aiControlBtn) {
    aiControlBtn.addEventListener('click', handleAIControlsClick);
  }

  var aiControlsContainer = document.querySelector('.ai-controls');
  if (aiControlsContainer) {
    aiControlsContainer.addEventListener('click', handleAIControlsClick);
  }

  function clampSpeechSpeed(value) {
    const slider = document.getElementById('speech-speed-slider');
    const min = slider ? parseFloat(slider.min || '0.5') : 0.5;
    const max = slider ? parseFloat(slider.max || '2.0') : 2.0;
    const num = parseFloat(value);
    if (!Number.isFinite(num)) {
      return 1.5;
    }
    if (num < min) {
      return min;
    }
    if (num > max) {
      return max;
    }
    return Math.round(num * 10) / 10;
  }

  function updateSpeechSpeedUI(value) {
    const slider = document.getElementById('speech-speed-slider');
    const display = document.getElementById('speech-speed-value');
    const clamped = clampSpeechSpeed(value);
    if (slider) {
      if (slider.MaterialSlider && typeof slider.MaterialSlider.change === 'function') {
        slider.MaterialSlider.change(clamped);
      }
      slider.value = clamped;
    }
    if (display) {
      display.textContent = clamped.toFixed(1) + 'x';
    }
    return clamped;
  }

  function loadAISettings() {
    try {
      const audioEnabled = localStorage.getItem('audioEnabled') !== 'false';
      const voiceVolume = parseInt(
        localStorage.getItem('preferredVolume') || '50'
      );
      const sfxVolume = parseInt(
        localStorage.getItem('preferredSfxVolume') || '50'
      );
      const speechGenerationEnabled = localStorage.getItem('speechGenerationEnabled') !== 'false';
      const speechSpeed = parseFloat(
        localStorage.getItem('speechSpeed') || '1.0'
      );
      const speechLanguage = localStorage.getItem('preferredSpeechLanguage') || 'en';

      let rawMakeArtEnabled = localStorage.getItem('makeArtEnabled');
      if (rawMakeArtEnabled === null) {
        localStorage.setItem('makeArtEnabled', 'false');
        rawMakeArtEnabled = 'false';
      }
      const makeArtEnabled = (rawMakeArtEnabled || '').toLowerCase() === 'true';
      let makeArtPromptAddition = localStorage.getItem('makeArtPromptAddition');
      if (makeArtPromptAddition === null || !makeArtPromptAddition.trim()) {
        makeArtPromptAddition = 'anime';
        localStorage.setItem('makeArtPromptAddition', makeArtPromptAddition);
      }
      const makeArtModel = localStorage.getItem('makeArtModel') || 'default';
      const makeArtSize = localStorage.getItem('makeArtSize') || '1024x1024';

      const audioEnabledSwitch = document.getElementById(
        'audio-enabled-switch'
      );
      const voiceVolumeSlider = document.getElementById('voice-volume-slider');
      const sfxVolumeSlider = document.getElementById('sfx-volume-slider');
      const speechGenerationSwitch = document.getElementById('speech-generation-switch');
      const speechSpeedSlider = document.getElementById('speech-speed-slider');
      const speechLanguageSettings = document.getElementById('speech-language-settings');
      const makeArtCheckbox = document.getElementById('make-art-checkbox');
      const makeArtPromptInput = document.getElementById('make-art-prompt-input');
      const makeArtModelSelect = document.getElementById('make-art-model-select');
      const makeArtSizeSelect = document.getElementById('make-art-size-select');

      if (audioEnabledSwitch) audioEnabledSwitch.checked = audioEnabled;
      if (voiceVolumeSlider) voiceVolumeSlider.value = voiceVolume;
      if (speechGenerationSwitch) speechGenerationSwitch.checked = speechGenerationEnabled;
      if (speechSpeedSlider) {
        updateSpeechSpeedUI(speechSpeed);
      }
      if (speechLanguageSettings) speechLanguageSettings.value = speechLanguage;
      if (sfxVolumeSlider) sfxVolumeSlider.value = sfxVolume;
      if (makeArtCheckbox) makeArtCheckbox.checked = makeArtEnabled;
      if (makeArtPromptInput) {
        makeArtPromptInput.value = makeArtPromptAddition;
        makeArtPromptInput.disabled = !makeArtEnabled;
      }
      if (makeArtCheckbox && makeArtPromptInput && !makeArtPromptInput.dataset.makeArtBound) {
        makeArtPromptInput.dataset.makeArtBound = '1';
        makeArtCheckbox.addEventListener('change', () => {
          const enabled = makeArtCheckbox.checked;
          makeArtPromptInput.disabled = !enabled;
          if (enabled && !makeArtPromptInput.value.trim()) {
            makeArtPromptInput.value = 'anime';
          }
        });
      }
      if (makeArtModelSelect) makeArtModelSelect.value = makeArtModel;
      if (makeArtSizeSelect) makeArtSizeSelect.value = makeArtSize;

      const volumeControls = document.getElementById('volume-controls');
      if (volumeControls) {
        volumeControls.style.display = audioEnabled ? 'block' : 'none';
      }

      const speechSpeedControls = document.getElementById('speech-speed-controls');
      if (speechSpeedControls) {
        speechSpeedControls.style.display = speechGenerationEnabled ? 'block' : 'none';
      }
    } catch (e) {
      console.error('Error loading AI settings:', e);
    }
  }

  function saveAISettings() {
    try {
      const audioEnabledSwitch = document.getElementById(
        'audio-enabled-switch'
      );
      const voiceVolumeSlider = document.getElementById('voice-volume-slider');
      const sfxVolumeSlider = document.getElementById('sfx-volume-slider');
      const speechGenerationSwitch = document.getElementById('speech-generation-switch');
      const speechSpeedSlider = document.getElementById('speech-speed-slider');
      const speechLanguageSettings = document.getElementById('speech-language-settings');
      const makeArtCheckbox = document.getElementById('make-art-checkbox');
      const makeArtPromptInput = document.getElementById('make-art-prompt-input');
      const makeArtModelSelect = document.getElementById('make-art-model-select');
      const makeArtSizeSelect = document.getElementById('make-art-size-select');

      if (audioEnabledSwitch) {
        localStorage.setItem(
          'audioEnabled',
          audioEnabledSwitch.checked.toString()
        );
      }
      if (speechGenerationSwitch) {
        localStorage.setItem(
          'speechGenerationEnabled',
          speechGenerationSwitch.checked.toString()
        );
      }
      if (speechSpeedSlider) {
        localStorage.setItem('speechSpeed', speechSpeedSlider.value);
      }
      if (speechLanguageSettings && speechLanguageSettings.value) {
        localStorage.setItem('preferredSpeechLanguage', speechLanguageSettings.value);
      }
      if (voiceVolumeSlider) {
        localStorage.setItem('preferredVolume', voiceVolumeSlider.value);

        // setVolume function will be called if available
        // This is handled by game-specific code
      }
      if (sfxVolumeSlider) {
        localStorage.setItem('preferredSfxVolume', sfxVolumeSlider.value);

        // setSfxVolume function will be called if available
        // This is handled by game-specific code
      }
      if (makeArtCheckbox) {
        localStorage.setItem(
          'makeArtEnabled',
          makeArtCheckbox.checked.toString()
        );
        if (makeArtCheckbox.checked && makeArtPromptInput && !makeArtPromptInput.value.trim()) {
          makeArtPromptInput.value = 'anime';
        }
      }
      if (makeArtPromptInput) {
        const addition = makeArtPromptInput.value.trim();
        localStorage.setItem(
          'makeArtPromptAddition',
          addition || ''
        );
      }
      if (makeArtModelSelect) {
        localStorage.setItem('makeArtModel', makeArtModelSelect.value || 'default');
      }
      if (makeArtSizeSelect) {
        localStorage.setItem('makeArtSize', makeArtSizeSelect.value || '1024x1024');
      }

      const aiSettingsDialog = document.getElementById('ai-settings-dialog');
      if (aiSettingsDialog) {
        aiSettingsDialog.close();
      }

      console.log('AI settings saved successfully');
    } catch (e) {
      console.error('Error saving AI settings:', e);
      alert('Error saving settings. Please try again.');
    }
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  $(document).ready(function () {
    const audioEnabledSwitch = document.getElementById('audio-enabled-switch');
    if (audioEnabledSwitch) {
      audioEnabledSwitch.addEventListener('change', function () {
        const volumeControls = document.getElementById('volume-controls');
        if (volumeControls) {
          volumeControls.style.display = this.checked ? 'block' : 'none';
        }
        try {
          localStorage.setItem('audioEnabled', this.checked.toString());
        } catch (err) {}
        if (!this.checked && typeof window.resetAudioPlayback === 'function') {
          window.resetAudioPlayback();
        }
      });
    }

    const speechGenerationSwitch = document.getElementById('speech-generation-switch');
    if (speechGenerationSwitch) {
      speechGenerationSwitch.addEventListener('change', function () {
        const speechSpeedControls = document.getElementById('speech-speed-controls');
        if (speechSpeedControls) {
          speechSpeedControls.style.display = this.checked ? 'block' : 'none';
        }
        try {
          localStorage.setItem('speechGenerationEnabled', this.checked.toString());
        } catch (err) {}
        if (!this.checked && typeof window.resetAudioPlayback === 'function') {
          window.resetAudioPlayback();
        }
      });
    }

    const speechSpeedSlider = document.getElementById('speech-speed-slider');
    if (speechSpeedSlider) {
      const handleSpeechSpeedInput = function () {
        const value = updateSpeechSpeedUI(this.value);
        try {
          localStorage.setItem('speechSpeed', value.toString());
        } catch (err) {}
      };
      speechSpeedSlider.addEventListener('input', handleSpeechSpeedInput);
      speechSpeedSlider.addEventListener('change', handleSpeechSpeedInput);
    }

    const debouncedSetVolume = debounce(function (value) {
      // setVolume function will be called if available
    }, 300);

    const debouncedSetSfxVolume = debounce(function (value) {
      // setSfxVolume function will be called if available
    }, 300);

    const voiceVolumeSlider = document.getElementById('voice-volume-slider');
    if (voiceVolumeSlider) {
      voiceVolumeSlider.addEventListener('input', function () {
        const volumeValue = document.getElementById('voice-volume-value');
        if (volumeValue) {
          volumeValue.textContent = this.value;
        }

        // setVolume function will be called if available
        // Immediate feedback handled by game-specific code

        debouncedSetVolume(this.value);
      });
    }

    const sfxVolumeSlider = document.getElementById('sfx-volume-slider');
    if (sfxVolumeSlider) {
      sfxVolumeSlider.addEventListener('input', function () {
        const volumeValue = document.getElementById('sfx-volume-value');
        if (volumeValue) {
          volumeValue.textContent = this.value;
        }

        debouncedSetSfxVolume(this.value);
      });
    }

    const saveBtn = document.getElementById('save-ai-settings-btn');
    if (saveBtn) {
      saveBtn.addEventListener('click', saveAISettings);
    }
  });
};

if (window.jQuery && typeof window.jQuery === 'function') {
  $(document).ready(__sharedReady);
} else if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', __sharedReady);
} else {
  __sharedReady();
}

(function syncHeaderCredits() {
  if (window.userData && window.userData.credits != null) {
    var els = document.getElementsByClassName('credits-value');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = parseFloat(window.userData.credits).toFixed(2);
    }
  }
})();

function isEbankLayout() {
  return document.documentElement.classList.contains('ebank-site') ||
    !!document.querySelector('.ebank-logo') ||
    /(^|\.)ebank\./.test(window.location.hostname);
}

function adsFix() {
  if (isEbankLayout()) return;
  var containers = document.getElementsByClassName('mdl-layout__container');
  for (var i = 0; i < containers.length; i++) {
    if (containers[i]) containers[i].style.height = '100%';
  }
  var layouts = document.getElementsByClassName('mdl-layout');
  for (var j = 0; j < layouts.length; j++) {
    if (layouts[j]) layouts[j].style.height = '';
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(adsFix, { timeout: 2000 });
} else {
  setTimeout(adsFix, 0);
}

function resetElements(elements) {
  for (var i = 0; i < elements.length; i++) {
    var element = elements[i];
    element.style.height = '';
  }
}
var timingFix = function () {
  if (isEbankLayout()) return;
  var flexes = document.getElementsByClassName('mdl-layout__container');
  for (var i = 0; i < flexes.length; i++) {
    if (flexes[i]) flexes[i].style.height = '100%';
  }
  var elements = document.getElementsByClassName('mdl-layout');
  resetElements(elements);
};

window.setInterval(timingFix, 8000);

function choose(choices) {
  var index = Math.floor(Math.random() * choices.length);
  return choices[index];
}

window.setupStripe = async function setupStripe(forceRecreate = false) {
  // If already setup and not forcing recreate, just return
  if (window.stripeCheckout && !forceRecreate) {
    // Make sure it's still visible in the right container
    var stripeContainers = document.querySelectorAll('#stripe-checkout-dialog-content');
    if (stripeContainers.length > 0 && stripeContainers[0].children.length === 0) {
      // Container was cleared, remount
      try {
        window.stripeCheckout.mount(stripeContainers[0]);
      } catch (e) {
        window.stripeCheckout = null;
        return setupStripe(true);
      }
    }
    return;
  }

  let attempts = 0;
  while (typeof Stripe === 'undefined' && attempts < 20) {
    await new Promise((resolve) => setTimeout(resolve, 250));
    attempts++;
  }

  if (typeof Stripe === 'undefined') {
    console.warn('Stripe is not defined after waiting');
    throw new Error('Stripe.js did not load');
  }

  if (!fixtures || !fixtures.stripe_publishable_key) {
    console.warn('Stripe publishable key not found in fixtures');
    throw new Error('Stripe publishable key is not configured');
  }

  const stripe = Stripe(fixtures.stripe_publishable_key);
  window.stripeCheckout = false;

  // Always prefer same-origin for API calls to avoid cross-domain cookie/CSRF issues
  // Server renders pages with the right domain; relative paths work across ebank/netwrck/v5games
  var baseUrl = '';

  // Helper: resolve user info robustly (window, localStorage, API)
  async function resolveUser() {
    try {
      if (window.userData && window.userData.id) return window.userData;

      // Fallback: legacy localStorage cache
      try {
        const cached = localStorage.getItem('netwrck_user');
        if (cached) {
          const parsed = JSON.parse(cached);
          const u = parsed.user || parsed;
          if (u && u.id) {
            window.userData = u;
            return u;
          }
        }
      } catch { /* Error ignored */ }

      // Final fallback: ask server (use APIClient if available to attach secret)
      let resp;
      if (window.APIClient && typeof window.APIClient.get === 'function') {
        resp = await window.APIClient.get('/api/current-user');
      } else {
        // Attach api_key if secret known via cookies/localStorage
        try {
          const cookies = document.cookie.split(';').reduce((acc, c) => { const [k,v] = c.trim().split('='); acc[k]=v; return acc; }, {});
          const secret = (window.userData && (window.userData.secret || window.userData.api_key)) || cookies.user_secret || '';
          const url = secret ? `/api/current-user?api_key=${encodeURIComponent(secret)}` : '/api/current-user';
          resp = await fetch(url, { credentials: 'include' });
        } catch (_) {
          resp = await fetch('/api/current-user', { credentials: 'include' });
        }
      }
      if (resp.ok) {
        const j = await resp.json();
        const u = j && (j.user || j.user_data || j.data);
        if (u && u.id) {
          window.userData = u;
          return u;
        }
      }
    } catch { /* Error ignored */ }
    return null;
  }

  try {
    // Resolve authenticated user; do not require secret for embedded checkout
    const user = await resolveUser();
    if (!user || !user.id) {
      console.warn('[setupStripe] No logged-in user found yet');
      throw new Error('Please log in to subscribe');
    }

    const response = await fetch(
      baseUrl + '/create-checkout-session-embedded',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          uid: user.id,
          // Secret optional for embedded subscription; include if present
          secret: user.secret || user.api_key || '',
          email: user.email,
          referral: CookieUtils.getCookie('evangeler_ref'),
        }),
      }
    );

    const data = await response.json();

    if (!data || !data.clientSecret) {
      console.warn('No client secret returned from server. Response:', data);
      throw new Error((data && data.error) || 'No client secret returned from server');
    }

    const { clientSecret } = data;
    
    // Only look for the container in the subscribe dialog, not globally
    var dialog = document.getElementById('subscribe-dialog');
    var stripeContainer = dialog ? dialog.querySelector('#stripe-checkout-dialog-content') : 
                          document.querySelector('#stripe-checkout-dialog-content');
    
    if (!stripeContainer) {
      console.warn('Stripe checkout container not found in subscribe dialog');
      throw new Error('Stripe checkout container not found');
    }

    // Clear container if forcing recreate or not initialized
    if (forceRecreate || !window.stripeCheckout) {
      stripeContainer.innerHTML = '';
      
      // Destroy existing checkout if forcing recreate
      if (forceRecreate && window.stripeCheckout) {
        try {
          window.stripeCheckout.destroy();
          window.stripeCheckout = null;
        } catch (e) {
          console.warn('Error destroying checkout:', e);
          window.stripeCheckout = null;
        }
      }
    }

    // Only create and mount if not already done or forcing recreate
    if (!window.stripeCheckout || window.stripeCheckout === false || forceRecreate) {
      // Ensure no duplicate Embedded Checkout instances exist
      if (
        window.EmbeddedCheckout &&
        typeof window.EmbeddedCheckout.destroyAll === 'function'
      ) {
        try {
          window.EmbeddedCheckout.destroyAll();
        } catch { /* Error ignored */ }
      }

      // Try to associate checkout with a parent dialog for lifecycle handling
      const parentDialog =
        document.getElementById('subscribe-dialog') ||
        document.getElementById('stripe-checkout-modal') ||
        null;

      window.stripeCheckout = await stripe.initEmbeddedCheckout({
        clientSecret,
        onComplete: function handleComplete() {
          if (window.stripeCheckout) {
            window.stripeCheckout.destroy();
          }
          try {
            if (window.userData) window.userData.is_subscribed = true;
          } catch { /* Error ignored */ }
          window.stripeCheckout = null;
          try {
            if (window.thFunnel) window.thFunnel.purchase('monthly', (window.evangelPurchaseAmounts || {}).monthly || 9, { flow: 'subscription' });
          } catch { /* Error ignored */ }
          try {
            if (typeof window.evangelTrackConversion === 'function') {
              var u = window.userData || user || {};
              var firstOnly = window.evangelFirstPurchaseOnly === true;
              var purchaseAmounts = window.evangelPurchaseAmounts || {};
              var purchaseAmount = purchaseAmounts.monthly || 9;
              var purchaseID = firstOnly
                ? 'first_purchase_' + window.location.hostname + '_' + (u.id || u.email || '')
                : 'sub_' + (u.id || '') + '_' + Date.now();
              window.evangelTrackConversion(purchaseAmount, purchaseID, u.email);
            }
          } catch { /* Error ignored */ }
          try {
            const d =
              parentDialog ||
              document.getElementById('subscribe-dialog') ||
              document.getElementById('stripe-checkout-modal');
            if (d && typeof d.close === 'function' && d.open) {
              d.close();
            } else if (d) {
              d.removeAttribute && d.removeAttribute('open');
              d.style && (d.style.display = 'none');
            }
          } catch { /* Error ignored */ }
          setTimeout(() => {
            window.location.reload();
          }, 50);
        },
      });

      window.stripeCheckout.mount(stripeContainer);
    }
    try {
      if (parentDialog) parentDialog.checkoutInstance = window.stripeCheckout;
    } catch { /* Error ignored */ }

  } catch (error) {
    console.error('Error setting up Stripe:', error);
    const dialog = document.getElementById('subscribe-dialog');
    const loadingEl = dialog && dialog.querySelector('#subscribe-checkout-loading');
    const errorEl = dialog && dialog.querySelector('#subscribe-checkout-error');
    if (loadingEl) loadingEl.style.display = 'none';
    if (errorEl) {
      errorEl.style.display = 'block';
      errorEl.textContent = error.message || 'Error loading payment form. Please try again.';
    }
    throw error;
  }
};

function loadDefaultAICharacters() {
  const autoCompleteUsersList = document.getElementById(
    'autoCompleteUsersList'
  );
  if (!autoCompleteUsersList) {
    console.warn('autoCompleteUsersList element not found');
    return;
  }

const loadingProgress = document.getElementById('search-ai-loading-progress');

window.addAllowNSFWParam = function (params) {
  try {
    if (
      typeof window !== 'undefined' &&
      window.userData &&
      (window.userData.allow_nsfw || window.userData.AllowNSFW)
    ) {
      params.set('allow_nsfw', 'true');
    }
  } catch (e) {
    console.warn('Failed to append allow_nsfw param', e);
  }
  return params;
};
  if (loadingProgress) {
    // Avoid CLS: toggle visibility without changing layout
    loadingProgress.style.visibility = 'visible';
  }

  // Fetch user characters, top AIs, and a default search-ais set (empty query)
  Promise.allSettled([
    dataAccessor.userAIs && typeof dataAccessor.userAIs === 'function'
      ? dataAccessor.userAIs(window.userData?.secret)
      : Promise.resolve([]),
    fetch('/api/top-ais').then((r) =>
      r.ok ? r.json() : Promise.reject(new Error('top-ais failed'))
    ),
    (() => {
      const p = new URLSearchParams({ query: 'popular', limit: '50' });
      if (window.addAllowNSFWParam) window.addAllowNSFWParam(p);
      return fetch('/api/search-ais?' + p.toString(), { credentials: 'include' })
        .then((r) => (r.ok ? r.json() : []))
        .catch(() => []);
    })(),
  ])
    .then((results) => {
      let userAIs = [];
      let topOrPopularAIs = [];
      let defaultSearchAIs = [];

      // User-created AIs
      if (results[0].status === 'fulfilled') {
        const userResult = results[0].value;
        if (userResult && userResult.data && Array.isArray(userResult.data)) {
          userAIs = userResult.data;
        } else if (Array.isArray(userResult)) {
          userAIs = userResult;
        }
      }

      // Top AIs (or fixture in dev)
      if (results[1].status === 'fulfilled') {
        const popularResult = results[1].value;
        if (
          popularResult &&
          popularResult.data &&
          Array.isArray(popularResult.data)
        ) {
          topOrPopularAIs = popularResult.data;
        } else if (Array.isArray(popularResult)) {
          topOrPopularAIs = popularResult;
        }
      }

      // Default search dataset from /api/search-ais (empty query)
      if (results[2].status === 'fulfilled') {
        const searchValue = results[2].value;
        if (Array.isArray(searchValue)) {
          defaultSearchAIs = searchValue;
        } else if (searchValue && Array.isArray(searchValue.data)) {
          defaultSearchAIs = searchValue.data;
        }
      }

      // Merge with priority: user AIs, then top/popular, then default search
      const seen = new Set();
      const combined = [];
      const pushUnique = (arr) => {
        for (const ai of arr || []) {
          const key = (ai.Name || ai.name || '').toLowerCase();
          if (!key || seen.has(key)) continue;
          seen.add(key);
          combined.push(ai);
        }
      };
      pushUnique(userAIs);
      pushUnique(topOrPopularAIs);
      pushUnique(defaultSearchAIs);

      displayAICharacters(combined);
    })
    .catch((error) => {
      console.error('Error loading AI characters:', error);
      autoCompleteUsersList.innerHTML =
        '<p class="error-message">Failed to load AI characters. Please try again.</p>';
    })
    .finally(() => {
      if (loadingProgress) {
        loadingProgress.style.visibility = 'hidden';
      }
    });
}

function displayCombinedAICharacters(userAIs, popularAIs) {
  const autoCompleteUsersList = document.getElementById(
    'autoCompleteUsersList'
  );
  if (!autoCompleteUsersList) {
    return;
  }

  autoCompleteUsersList.innerHTML = '';

  if (
    (!userAIs || userAIs.length === 0) &&
    (!popularAIs || popularAIs.length === 0)
  ) {
    autoCompleteUsersList.innerHTML =
      '<div class="mdl-cell mdl-cell--12-col"><p class="no-results" style="text-align: center; color: #666; margin: 20px;">No AI characters found.</p></div>';
    return;
  }

  if (userAIs && userAIs.length > 0) {
    const userHeader = document.createElement('div');
    userHeader.className = 'mdl-cell mdl-cell--12-col';
    userHeader.innerHTML =
      '<h6 style="margin: 16px 0 8px 0; color: #1976d2; font-weight: 500;">🎭 Your AI Characters</h6>';
    autoCompleteUsersList.appendChild(userHeader);

    userAIs.forEach((ai) => {
      const aiElement = createAICharacterElement(ai, true);
      autoCompleteUsersList.appendChild(aiElement);
    });
  }

  if (popularAIs && popularAIs.length > 0) {
    popularAIs.forEach((ai) => {
      const aiElement = createAICharacterElement(ai, false);
      autoCompleteUsersList.appendChild(aiElement);
    });
  }
}

function displayAICharacters(ais) {
  const autoCompleteUsersList = document.getElementById(
    'autoCompleteUsersList'
  );
  if (!autoCompleteUsersList) {
    return;
  }

  autoCompleteUsersList.innerHTML = '';
  autoCompleteUsersList.dataset.ownedPriority = 'true';

  if (!ais || ais.length === 0) {
    autoCompleteUsersList.innerHTML =
      '<div class="mdl-cell mdl-cell--12-col"><p class="no-results" style="text-align: center; color: #666; margin: 20px;">No AI characters found.</p></div>';
    return;
  }

  let hasUserAIs = false;
  let userAICount = 0;

  for (let i = 0; i < ais.length; i++) {
    if (ais[i].user__id || ais[i].IsUserCreated || ais[i].is_user_created) {
      userAICount++;
      hasUserAIs = true;
    } else {
      break;
    }
  }

  if (hasUserAIs && userAICount > 0) {
    const userHeader = document.createElement('div');
    userHeader.className = 'mdl-cell mdl-cell--12-col';
    userHeader.innerHTML =
      '<h6 style="margin: 16px 0 8px 0; color: #1976d2; font-weight: 500;">Your AIs</h6>';
    autoCompleteUsersList.appendChild(userHeader);

    for (let i = 0; i < userAICount; i++) {
      const aiElement = createAICharacterElement(ais[i], true);
      autoCompleteUsersList.appendChild(aiElement);
    }

    if (ais.length > userAICount) {
      for (let i = userAICount; i < ais.length; i++) {
        const aiElement = createAICharacterElement(ais[i]);
        autoCompleteUsersList.appendChild(aiElement);
      }
    }
  } else {
    const header = document.createElement('div');
    header.className = 'mdl-cell mdl-cell--12-col';
    header.innerHTML =
      '<h6 style="margin: 16px 0 8px 0; color: #424242; font-weight: 500;">AI Characters</h6>';
    autoCompleteUsersList.appendChild(header);

    ais.forEach((ai) => {
      const aiElement = createAICharacterElement(ai);
      autoCompleteUsersList.appendChild(aiElement);
    });
  }
}

function resolveAvatarUrl(fileName) {
  if (!fileName || fileName === 'None') {
    return 'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp';
  }
  let normalized = String(fileName).replace(' ', '-').trim();
  if (normalized.indexOf('static/uploads') === -1) {
    normalized = 'static/uploads/' + normalized;
  }
  return `https://netwrckstatic.netwrck.com/${normalized}`;
}

function createAICharacterElement(ai, isUserAI = false) {
  const aiName = ai.Name || ai.name || 'Unknown';
  const chatUrl = `/ai-chat/${encodeURIComponent(ai.url_name || ai.URLName || aiName)}`;

  let avatarUrl = null;
  if (ai.avatar_file_name && ai.avatar_file_name !== 'None') {
    avatarUrl = resolveAvatarUrl(ai.avatar_file_name);
  } else if (ai.AvatarFileName && ai.AvatarFileName !== 'None') {
    avatarUrl = resolveAvatarUrl(ai.AvatarFileName);
  } else if (ai.image_url) {
    avatarUrl = ai.image_url;
  } else {
    avatarUrl = resolveAvatarUrl(null);
  }

  const fallbackAvatarUrl =
    'https://netwrckstatic.netwrck.com/static/img/netwrck-logo-colord256.webp';
  const finalAvatarUrl = avatarUrl || fallbackAvatarUrl;

  const titleBackground = isUserAI
    ? 'linear-gradient(45deg, #1976d2, #1565c0)'
    : 'linear-gradient(45deg, #f0f0f0, #e0e0e0)';
  const titleColor = isUserAI ? 'white' : '#333';

  const wrapper = document.createElement('div');
  wrapper.className =
    'mdl-cell mdl-cell--4-col mdl-cell--12-col-tablet mdl-cell--12-col-phone mdl-cell--stretch';

  wrapper.innerHTML = `
    <a class="ai-character-item mdl-list__item mdl-list__item--three-line" href="${chatUrl}" data-bypass="true" style="position: relative; display: block; text-decoration: none; color: inherit; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.15); transition: transform 0.2s ease, box-shadow 0.2s ease;">
      <div class="ai-card-image" style="width: 100%; height: 200px; position: relative; overflow: hidden;">
        <img class="ai-avatar-icon" src="${finalAvatarUrl}" alt="${aiName}" style="width: 100%; height: 100%; object-fit: cover;" loading="lazy" decoding="async" referrerpolicy="no-referrer" onerror="this.src='${fallbackAvatarUrl}';">
        <div style="position: absolute; bottom: 0; left: 0; right: 0; background: linear-gradient(transparent, rgba(0,0,0,0.7)); height: 60px;"></div>
      </div>
      <div class="mdl-card__title" style="height: 60px; background: ${titleBackground}; position: relative; z-index: 2;">
        <div class="mdl-list__item-primary-content" style="width: 100%; padding: 12px;">
          <span class="ai-name mdl-chip__text" style="font-weight: 500; color: ${titleColor}; font-size: 16px; display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${aiName}</span>
        </div>
      </div>
      <div class="mdl-card__supporting-text" style="min-height: 60px; position: relative; z-index: 2; contain: content;">
        <span class="mdl-list__item-text-body">${
          ai.Description ||
          ai.description ||
          ai.Greeting ||
          `Chat with ${aiName} - an AI character ready for conversation!`
        }</span>
      </div>
    </a>
  `;

  return wrapper;
}

function searchAICharacters(query) {
  const autoCompleteUsersList = document.getElementById(
    'autoCompleteUsersList'
  );
  if (!autoCompleteUsersList) {
    return;
  }

  const loadingProgress = document.getElementById('search-ai-loading-progress');
  if (loadingProgress) {
    loadingProgress.style.visibility = 'visible';
  }

  const apiBaseUrl =
    window.fixtures && window.fixtures.api_base_url
      ? window.fixtures.api_base_url
      : '';

  if (!query || query.trim() === '') {
    loadDefaultAICharacters();
    return;
  }

  const liveParams = new URLSearchParams({ query: query });
  if (window.addAllowNSFWParam) {
    window.addAllowNSFWParam(liveParams);
  }

  // Try live search; if it fails, fallback to filtering local fixture
  fetch('/api/search-ais?' + liveParams.toString(), { credentials: 'include' })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.status);
      }
      return response.json();
    })
    .then((result) => {
      let ais = [];
      if (result.data && Array.isArray(result.data)) {
        ais = result.data;
      } else if (Array.isArray(result)) {
        ais = result;
      }
      displayAICharacters(ais);
    })
    .catch(() => {
      return fetch('/static/data/search_ais_fixture.json')
        .then((r) => r.json())
        .then((ais) => {
          const q = String(query).toLowerCase();
          const filtered = ais.filter((ai) => {
            const haystack = [ai.name, ai.title, ai.description, ai.greeting]
              .filter(Boolean)
              .join(' ')
              .toLowerCase();
            const hasTag =
              Array.isArray(ai.tags) &&
              ai.tags.some((t) => String(t).toLowerCase().includes(q));
            return haystack.includes(q) || hasTag;
          });
          displayAICharacters(filtered);
        });
    })
    .finally(() => {
      if (loadingProgress) {
        loadingProgress.style.visibility = 'hidden';
      }
    });
}

$(document).ready(function () {
  const addChatDialog = document.getElementById('add-chat-dialog');
  if (addChatDialog) {
    addChatDialog.addEventListener('showmodal', function () {
      loadDefaultAICharacters();
    });

    const originalShowModal = addChatDialog.showModal;
    addChatDialog.showModal = function () {
      originalShowModal.call(this);
      loadDefaultAICharacters();
    };
  }

  const searchInput = document.getElementById('searchusers');
  const hasAppSearch = () => typeof window.APPController !== 'undefined' && typeof window.APPController.renderAIs === 'function';
  if (searchInput && !hasAppSearch()) {
    let searchTimeout;
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(() => {
        if (hasAppSearch()) return;
        searchAICharacters(this.value);
      }, 300);
    });

    searchInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(searchTimeout);
        if (hasAppSearch()) return;
        searchAICharacters(this.value);
      }
    });
  }

  const searchButton = document.querySelector('.search-ais-button');
  if (searchButton && !hasAppSearch()) {
    searchButton.addEventListener('click', function () {
      if (hasAppSearch()) return;
      const searchInput = document.getElementById('searchusers');
      if (searchInput) {
        searchAICharacters(searchInput.value);
      }
    });
  }
});

function searchCat(category) {
  const searchInput = document.getElementById('searchusers');
  if (searchInput) {
    searchInput.value = category;
    if (window.APPController && typeof window.APPController.renderAIs === 'function') {
      window.APPController.renderAIs('#autoCompleteUsersList', category);
    } else {
      searchAICharacters(category);
    }
  }
  return false;
}

// Lightweight reentrancy/throttle guard to prevent dialog freezing on rapid double-open
if (!window.__subscribeDialogState) {
  window.__subscribeDialogState = { opening: false, lastOpenAt: 0 };
}

window.showSubscribeDialog = function (event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  const now = Date.now();
  if (window.__subscribeDialogState.opening) {
    return false;
  }
  // Ignore bursts of rapid clicks
  if (now - (window.__subscribeDialogState.lastOpenAt || 0) < 400) {
    return false;
  }

  // Use embedded checkout if available - it handles modal state properly
  if (window.EmbeddedCheckout && typeof window.EmbeddedCheckout.open === 'function') {
    window.EmbeddedCheckout.open({ type: 'subscription' });
    return false;
  }

  // Fallback to direct modal manipulation
  const subscribeDialog = document.getElementById('subscribe-dialog');
  if (subscribeDialog && typeof subscribeDialog.showModal === 'function') {
    // Check if we're on a page that needs special handling due to multiple dialogs
    const needsDeduplication = window.location.pathname === '/account' || 
                               window.location.pathname === '/ebankaccount' ||
                               window.location.pathname.includes('ra1-art-generator') ||
                               window.location.pathname.includes('ra2-art-generator') ||
                               window.location.pathname.includes('ra2-image-editor') ||
                               window.location.pathname.includes('ltxv-video-generator') ||
                               window.location.pathname.includes('ltx2-video-generator') ||
                               window.location.pathname.includes('video-editor');
    
    if (needsDeduplication) {
      // For pages with multiple dialogs, destroy any existing Stripe instances first
      // This prevents freezing when reopening the dialog
      try {
        // Destroy any existing embedded checkout instances
        if (window.EmbeddedCheckout && typeof window.EmbeddedCheckout.destroyAll === 'function') {
          window.EmbeddedCheckout.destroyAll();
        }
        
        // Destroy any existing stripe checkout instance
        if (window.stripeCheckout && typeof window.stripeCheckout.destroy === 'function') {
          window.stripeCheckout.destroy();
          window.stripeCheckout = null;
        }
        
        // Clear any checkout instance attached to the dialog
        if (subscribeDialog.checkoutInstance && typeof subscribeDialog.checkoutInstance.destroy === 'function') {
          subscribeDialog.checkoutInstance.destroy();
          subscribeDialog.checkoutInstance = null;
        }
        
        // Clear the checkout element content to force recreation
        const checkoutEl = subscribeDialog.querySelector('#subscribe-checkout-element');
        if (checkoutEl) {
          checkoutEl.innerHTML = '';
        }
      } catch (e) {
        console.warn('[Subscribe] Error cleaning up Stripe instances:', e);
      }
    }
    
    // If dialog is already open, just ensure correct section visibility and focus instead of closing/reopening
    if (subscribeDialog.open === true) {
      try {
        const loginSection = subscribeDialog.querySelector('.header-login-signup');
        const stripeSection = subscribeDialog.querySelector('#stripe-checkout-dialog-content');
        const hasUser = !!(window.userData && window.userData.id);
        if (hasUser) {
          if (loginSection) loginSection.style.display = 'none';
          if (stripeSection) stripeSection.style.display = 'block';
        } else {
          if (loginSection) loginSection.style.display = 'block';
          if (stripeSection) stripeSection.style.display = 'none';
        }
        // Focus the dialog to bring it to front
        if (typeof subscribeDialog.focus === 'function') {
          subscribeDialog.focus();
        }
      } catch (e) { /* ignore focus/display errors */ }
      return false;
    }
    
    // Update dialog content based on user authentication
    const loginSection = subscribeDialog.querySelector('.header-login-signup');
    const stripeSection = subscribeDialog.querySelector(
      '#stripe-checkout-dialog-content'
    );
    const hasUser = !!(window.userData && window.userData.id);
    if (hasUser) {
      // User is logged in, show Stripe section
      if (loginSection) {
        loginSection.style.display = 'none';
      }
      if (stripeSection) {
        stripeSection.style.display = 'block';
        // Load Stripe - force recreation on pages with multiple dialogs
        if (window.setupStripe) {
          const forceRecreate = needsDeduplication; // Force recreation on pages with multiple dialogs
          if (!window.stripeCheckout || forceRecreate) {
            window.setupStripe(forceRecreate).catch((error) => {
              console.error('Error setting up Stripe:', error);
              stripeSection.innerHTML =
                '<div style="padding: 20px; text-align: center;"><p>Error loading payment form. Please try again.</p></div>';
            });
          }
        }
      }
    } else {
      // User is not logged in, show login/signup section
      if (loginSection) {
        loginSection.style.display = 'block';
      }
      if (stripeSection) {
        stripeSection.style.display = 'none';
      }

      // First-open race: user may have just signed up; try to hydrate and then swap to Stripe automatically
      (async () => {
        try {
          // small delay to allow session cookies to settle
          await new Promise((r) => setTimeout(r, 300));
          const resp = await fetch('/api/current-user', { credentials: 'include' });
          if (resp.ok) {
            const j = await resp.json();
            const u = j && (j.user || j.user_data || j.data);
            if (u && u.id) {
              window.userData = u;
              // swap sections
              if (loginSection) loginSection.style.display = 'none';
              if (stripeSection) {
                stripeSection.style.display = 'block';
                if (!window.stripeCheckout && window.setupStripe) {
                  try { await window.setupStripe(); } catch (e) {
                    console.error('Stripe init after hydration failed:', e);
                    stripeSection.innerHTML = '<div style="padding: 20px; text-align: center;"><p>Error loading payment form. Please try again.</p></div>';
                  }
                }
              }
            }
          }
        } catch (e) {
          // keep login section; non-fatal
        }
      })();
    }

    // Guard open to avoid reentrancy freeze
    window.__subscribeDialogState.opening = true;
    window.__subscribeDialogState.lastOpenAt = now;
    try {
      subscribeDialog.showModal();
    } finally {
      // Release opening flag shortly after to absorb quick double-clicks
      setTimeout(() => { window.__subscribeDialogState.opening = false; }, 300);
    }
  } else {
    console.warn('Subscribe dialog not found or showModal not supported');
  }

  return false;
};

// AI Art Generation functionality
function getSharedAuthSecret() {
  if (window.netwrckGetAuthSecret) {
    var helperSecret = window.netwrckGetAuthSecret();
    if (helperSecret) return helperSecret;
  }
  var candidates = [
    window.userData && (window.userData.secret || window.userData.api_key),
    window.userSecret,
    localStorage.getItem('userSecret'),
    sessionStorage.getItem('user_secret'),
  ];
  for (var i = 0; i < candidates.length; i++) {
    var secret = String(candidates[i] || '').trim();
    if (
      secret &&
      secret !== 'anonymous' &&
      secret !== 'secret' &&
      secret !== 'YOUR_API_KEY' &&
      secret !== 'null' &&
      secret !== 'undefined'
    ) {
      return secret;
    }
  }
  return '';
}

async function generateSharedImages3Art(prompt, width, height) {
  const params = new URLSearchParams({
    prompt: prompt,
    width: String(width),
    height: String(height),
    source: 'images3',
  });
  const response = await fetch(
    '/api/create-and-upload-image?' + params.toString(),
    {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'include',
    }
  );
  if (!response.ok) {
    throw new Error(`images3 generation failed: ${response.status}`);
  }
  const data = await response.json();
  const imageUrl = data && (data.path || data.image_url);
  if (!imageUrl) throw new Error('images3 response did not include an image');
  return imageUrl;
}

let sharedGeneratedImageSequence = 0;

async function generateAIArt() {
  const prompt = document.getElementById('createaiimageprompt');
  if (!prompt || !prompt.value.trim()) {
    alert('Please enter a prompt for AI art generation');
    return;
  }

  const selectedAspect = document.querySelector('input[name="aspect"]:checked');
  if (!selectedAspect) {
    alert('Please select an aspect ratio');
    return;
  }

  // Show loading indicator
  const loadingProgress = document.getElementById('create-ai-loading-progress');
  if (loadingProgress) {
    loadingProgress.style.display = 'block';
  }

  // Get aspect ratio dimensions
  let width = 1024,
    height = 1024;
  switch (selectedAspect.id) {
    case 'squareaspect':
      width = 1024;
      height = 1024;
      break;
    case 'landscapeaspect':
      width = 1152;
      height = 768;
      break;
    case 'portraitaspect':
      width = 768;
      height = 1152;
      break;
    case 'landscape43aspect':
      width = 1152;
      height = 864;
      break;
    case 'portrait43aspect':
      width = 864;
      height = 1152;
      break;
    case 'widescreenaspect':
      width = 1360;
      height = 768;
      break;
    case 'tallaspect':
      width = 768;
      height = 1360;
      break;
  }

  const requestData = {
    prompt: prompt.value.trim(),
    image_size: {
      width: width,
      height: height,
    },
    num_inference_steps: 4,
    num_images: 1,
    enable_safety_checker: false,
  };

  try {
    await Promise.resolve(window.userDataReady || window.userData);
  } catch {}
  const secret = getSharedAuthSecret();
  const headers = {
    'Content-Type': 'application/json',
  };
  if (secret) {
    headers['X-API-Key'] = secret;
    headers['Authorization'] = 'Bearer ' + secret;
  }
  const body = {
    model_name: 'fal-ai/flux/schnell',
    ...requestData,
  };
  if (secret) body.api_key = secret;

  const falGeneration = fetch('/fal', {
    method: 'POST',
    headers: headers,
    credentials: 'include',
    body: JSON.stringify(body),
  })
    .then(async (response) => {
      if (response.status === 401) {
        if (typeof window.showLoginDialog === 'function') {
          window.showLoginDialog(null, window.location.pathname);
        }
        return { authRequired: true };
      }
      if (response.status === 402) {
        try {
          await response.json();
        } catch { /* Error ignored */ }
        if (typeof window.showSubscribeDialog === 'function') {
          window.showSubscribeDialog();
        }
        return { paymentRequired: true };
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      if (data && data.authRequired) {
        return;
      }
      if (data && data.paymentRequired) {
        return;
      }
      if (data.result && data.result.images && data.result.images.length > 0) {
        addImageToGallery(data.result.images[0]);
      } else {
        throw new Error('No images generated');
      }
    });

  const images3Generation = generateSharedImages3Art(
    prompt.value.trim(),
    width,
    height
  ).then((imageUrl) => addImageToGallery(imageUrl));

  const results = await Promise.allSettled([
    falGeneration,
    images3Generation,
  ]);
  results.forEach((result) => {
    if (result.status === 'rejected') {
      console.error('AI art generation error:', result.reason);
    }
  });
  if (loadingProgress) {
    loadingProgress.style.display = 'none';
  }
}

function addImageToGallery(imageData) {
  const gallery = document.getElementById('createdImagePicsList');
  if (!gallery) {
    console.error('Gallery element not found');
    return;
  }

  const imageUrl = imageData.url || imageData;
  const uniqueClass = `ai-generated-image-${Date.now()}-${sharedGeneratedImageSequence++}`;

  const imageDiv = document.createElement('div');
  imageDiv.className =
    'ai-char-item mdl-cell mdl-cell--stretch mdl-cell--6-col mdl-list__item mdl-list__item--three-line';

  imageDiv.innerHTML = `
        <a id="mdl-editor-btn-${uniqueClass}" href="https://editor.ebank.nz/index.html?imageUrl=${encodeURIComponent(imageUrl)}" class="mdl-editor-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank">
            <i class="material-icons">brush</i>
        </a>
        <label class="mdl-tooltip" data-mdl-for="mdl-editor-btn-${uniqueClass}">
            Open in Editor
        </label>
        <a id="mdl-download-btn-${uniqueClass}" class="mdl-editor-btn mdl-download-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="${uniqueClass}">
            <i class="material-icons">download</i>
        </a>
        <label class="mdl-tooltip" data-mdl-for="mdl-download-btn-${uniqueClass}">
            Download
        </label>
        <a id="mdl-upres-btn-${uniqueClass}" class="mdl-editor-btn mdl-upres-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="${uniqueClass}">
            <i class="material-icons">2k</i>
        </a>
        <label class="mdl-tooltip" data-mdl-for="mdl-upres-btn-${uniqueClass}">
            Upres + Eye Fix
        </label>
        <a id="mdl-video-btn-${uniqueClass}" class="mdl-editor-btn mdl-video-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="${uniqueClass}">
           <i class="material-icons">play_arrow</i>
        </a>
        <label class="mdl-tooltip" data-mdl-for="mdl-video-btn-${uniqueClass}">
            Make Video
        </label>
        <a id="mdl-style-transf-btn-${uniqueClass}" class="mdl-editor-btn mdl-style-transf-btn mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab mdl-button--colored" target="_blank" data-download="${uniqueClass}">
           <i class="material-icons">autorenew</i>
        </a>
        <label class="mdl-tooltip" data-mdl-for="mdl-style-transf-btn-${uniqueClass}">
            Style Transfer
        </label>
        <img loading="lazy" class="${uniqueClass} b8 ai-generated-char-chooser ai-generated-char-item" src="${imageUrl}" alt="art">
    `;

  gallery.insertBefore(imageDiv, gallery.firstChild);
}

// Initialize AI art generation button handler
$(document).ready(function () {
  $('.create-ai-image-button:not(#btn-generate-inline)').click(function (event) {
    event.preventDefault();
    generateAIArt();
  });
});
// Focus management for Add Chat dialog (search) with Firefox-friendly timing
(function () {
  const dialog = document.getElementById('add-chat-dialog');
  if (!dialog) return;

  let lastFocusedEl = null;
  let lastFocusedCandidate = null;

  // Track the element focused before a click that may open the dialog
  document.addEventListener(
    'mousedown',
    function () {
      try { lastFocusedCandidate = document.activeElement || null; } catch { /* Error ignored */ }
    },
    true
  );

  function focusSearchInputSoon() {
    setTimeout(() => {
      try {
        if (!dialog) return;
        const input = dialog.querySelector('#searchusers');
        if (input && typeof input.focus === 'function') {
          input.focus();
          if (typeof input.select === 'function') input.select();
        }
      } catch { /* Error ignored */ }
    }, 0);
  }

  dialog.addEventListener('showmodal', function () {
    if (!lastFocusedEl) lastFocusedEl = lastFocusedCandidate;
    focusSearchInputSoon();
  });

  // If anything wraps showModal elsewhere, this still ensures focus
  try {
    if (typeof dialog.showModal === 'function') {
      const origShow = dialog.showModal.bind(dialog);
      dialog.showModal = function () {
        try { lastFocusedEl = document.activeElement || lastFocusedCandidate || null; } catch { /* Error ignored */ }
        origShow();
        focusSearchInputSoon();
      };
    }
  } catch { /* Error ignored */ }

  dialog.addEventListener('close', function () {
    try {
      if (lastFocusedEl && document.contains(lastFocusedEl)) {
        lastFocusedEl.focus();
      }
    } catch { /* Error ignored */ }
    lastFocusedEl = null;
    lastFocusedCandidate = null;
  });

  // Delegate opener buttons if present
  document.addEventListener(
    'click',
    function (e) {
      const opener = e.target && e.target.closest
        ? e.target.closest('.search-ai-bots-button, [data-open="add-chat-dialog"]')
        : null;
      if (!opener) return;
      e.preventDefault();
      try { lastFocusedEl = document.activeElement || opener; } catch (_) { lastFocusedEl = opener; }
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else if (dialog) {
        dialog.setAttribute('open', 'open');
        dialog.style.display = 'block';
        dialog.dispatchEvent(new Event('showmodal'));
      }
    },
    true
  );
})();

// Screenshot share prompt - show toast when user takes a screenshot on mobile
(function initScreenshotSharePrompt() {
  if (typeof window === 'undefined') return;
  var isMobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isMobile) return;

  var lastHidden = 0;
  var prompted = false;
  var SCREENSHOT_THRESHOLD_MS = 800;

  function showShareToast() {
    if (prompted) return;
    prompted = true;
    setTimeout(function () { prompted = false; }, 30000);

    var toast = document.getElementById('toast');
    if (toast && toast.MaterialSnackbar) {
      toast.MaterialSnackbar.showSnackbar({
        message: 'Share a link instead?',
        actionText: 'Copy Link',
        actionHandler: function () {
          var url = window.location.href;
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(function () {
              toast.MaterialSnackbar.showSnackbar({ message: 'Link copied!' });
            });
          } else {
            var input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            toast.MaterialSnackbar.showSnackbar({ message: 'Link copied!' });
          }
        },
        timeout: 5000
      });
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      lastHidden = Date.now();
    } else {
      var delta = Date.now() - lastHidden;
      if (lastHidden > 0 && delta < SCREENSHOT_THRESHOLD_MS) {
        showShareToast();
      }
    }
  });
})();
